import {
  GET_COMPONENTES_SERIE,
  GET_COMPONENTES_SERIE_SUCCESS,
  SAVE_COMPONENTES_SERIE,
  SAVE_COMPONENTES_SERIE_SUCCESS,
  ON_HIDE_LOADER
} from "constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  componentesSerie: null, // Armazena o objeto completo recuperado do backend
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COMPONENTES_SERIE: {
      return { ...state, loader: true };
    }
    case GET_COMPONENTES_SERIE_SUCCESS: {
      return { ...state, loader: false, componentesSerie: action.payload };
    }
    case SAVE_COMPONENTES_SERIE: {
      return { ...state, loader: true };
    }
    case SAVE_COMPONENTES_SERIE_SUCCESS: {
      return { ...state, loader: false, componentesSerie: action.payload };
    }
    case ON_HIDE_LOADER: {
      return { ...state, loader: false };
    }
    default:
      return state;
  }
};
